import { useDocument } from "@/hooks/useFirestore"
import { createManagedMutations } from "@/hooks/useManagedMutations"
import { GlobalSettings, collectionName, mainDocumentId } from "./globalSettings"

export function useGlobalSettings() {
   return useDocument<GlobalSettings>(collectionName, mainDocumentId)
}

export const { useUpdateManagedDocument: useUpdateGlobalSettings } =
   createManagedMutations<GlobalSettings>(collectionName)
